import React from "react";
import { motion } from "framer-motion";
import { HiOutlineUserGroup, HiOutlineSparkles } from "react-icons/hi";
import UserProfile from "./UserProfile";
import InvitationsPanel from "./InvitationsPanel";

const Profile = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 relative overflow-hidden py-8 px-4 sm:px-6 lg:px-8"
    >
      {/* Animated Background Elements - Light Gray */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <motion.div 
          className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60"
          animate={{
            x: [0, 50, 0],
            y: [0, -30, 0],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        />
        <motion.div 
          className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60"
          animate={{
            x: [0, -50, 0],
            y: [0, 30, 0],
          }}
          transition={{
            duration: 18,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        />
        
        {/* Floating Icons - Light Gray */}
        <motion.div 
          className="absolute top-1/4 right-1/4 text-gray-200/40 hidden lg:block"
          animate={{
            y: [0, -20, 0],
            rotate: [0, 10, -10, 0]
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        >
          <HiOutlineUserGroup size={80} />
        </motion.div>

        <motion.div 
          className="absolute bottom-1/4 left-1/4 text-gray-200/40 hidden lg:block"
          animate={{
            y: [0, 20, 0],
            rotate: [0, -10, 10, 0]
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        >
          <HiOutlineSparkles size={70} />
        </motion.div>
      </div>

      {/* Header */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-7xl mx-auto mb-8"
      >
        <h1 className="text-3xl md:text-4xl font-bold text-gray-700">
          My Profile
        </h1>
        <p className="text-gray-600 mt-2">Manage your personal information and connections</p>
      </motion.div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8">
        {/* User Profile - Takes 2/3 on large screens */}
        <div className="lg:w-2/3">
          <UserProfile />
        </div>

        {/* Invitations Panel - Takes 1/3 on large screens */}
        <div className="lg:w-1/3">
          <InvitationsPanel />
        </div>
      </div>
    </motion.div>
  );
};

export default Profile;